<template>
  <div>
    <!-- サイドバーオーバーレイ（開いている時のみ） -->
    <transition name="backdrop-fade">
      <div
        v-if="!isCollapsed"
        class="sidebar-backdrop"
        @click="closeSidebar"
      ></div>
    </transition>

    <!-- サイドバー本体 -->
    <aside
      class="app-sidebar-container"
      :class="{ 'is-open': !isCollapsed, 'is-closed': isCollapsed }"
      role="navigation"
      aria-label="メインナビゲーション"
    >
      <!-- ブランドヘッダー & 閉じるボタン -->
      <div class="sidebar-header">
        <router-link to="/plan" class="sidebar-brand-link" :title="'RabiiTrip HOME'" @click="closeSidebar">
          <img src="/favicon.png" alt="" class="sidebar-logo-img" />
          <span class="sidebar-brand">RabiiTrip</span>
        </router-link>

        <button
          type="button"
          class="sidebar-close-btn"
          aria-label="サイドバーを閉じる"
          title="サイドバーを閉じる"
          @click="closeSidebar"
        >
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </button>
      </div>

      <!-- メインナビ -->
      <nav class="sidebar-main-nav">
        <router-link to="/plan" class="nav-item" :title="'HOME'" @click="closeSidebar">
          <svg class="nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <path d="M3 9.5L12 3l9 6.5V20a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V9.5z"/>
            <path d="M9 21V12h6v9"/>
          </svg>
          <span class="nav-text">HOME</span>
        </router-link>

        <router-link to="/destination-boards" class="nav-item" :title="'旅先検討'" @click="closeSidebar">
          <svg class="nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <circle cx="12" cy="12" r="10"/>
            <line x1="2" y1="12" x2="22" y2="12"/>
            <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/>
          </svg>
          <span class="nav-text">旅先検討</span>
        </router-link>

        <router-link to="/mypage" class="nav-item" :title="'旅程管理'" @click="closeSidebar">
          <svg class="nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"/>
            <rect x="8" y="2" width="8" height="4" rx="1" ry="1"/>
            <path d="M9 12h6"/>
            <path d="M9 16h6"/>
          </svg>
          <span class="nav-text">旅程管理</span>
        </router-link>

        <router-link to="/reviews" class="nav-item" :title="'評価'" @click="closeSidebar">
          <svg class="nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
          </svg>
          <span class="nav-text">評価</span>
        </router-link>
      </nav>

      <!-- しおり内サブナビ -->
      <div v-if="isShioriRoute" class="sidebar-sub-nav">
        <div class="sub-nav-label">しおりメニュー</div>
        <button
          :class="['nav-item', { active: activeTab === 'overview' }]"
          :title="'旅行概要'"
          @click="changeTab('overview')"
        >
          <svg class="nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/>
            <rect x="14" y="14" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/>
          </svg>
          <span class="nav-text">旅行概要</span>
        </button>
        <button
          :class="['nav-item', { active: activeTab === 'schedule' }]"
          :title="'スケジュール'"
          @click="changeTab('schedule')"
        >
          <svg class="nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/>
            <line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/>
          </svg>
          <span class="nav-text">スケジュール</span>
        </button>
        <button
          :class="['nav-item', { active: activeTab === 'belongings' }]"
          :title="'持ち物リスト'"
          @click="changeTab('belongings')"
        >
          <svg class="nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/>
          </svg>
          <span class="nav-text">持ち物</span>
        </button>
        <button
          :class="['nav-item', { active: activeTab === 'todo' }]"
          :title="'ToDoリスト'"
          @click="changeTab('todo')"
        >
          <svg class="nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <polyline points="9 11 12 14 22 4"/><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"/>
          </svg>
          <span class="nav-text">ToDo</span>
        </button>
        <button
          :class="['nav-item', { active: activeTab === 'warikan' }]"
          :title="'割り勘・費用'"
          @click="changeTab('warikan')"
        >
          <svg class="nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/>
          </svg>
          <span class="nav-text">割り勘</span>
        </button>
        <button
          :class="['nav-item', { active: activeTab === 'wishlist' }]"
          :title="'行きたいとこ'"
          @click="changeTab('wishlist')"
        >
          <svg class="nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/>
          </svg>
          <span class="nav-text">行きたいとこ</span>
        </button>
      </div>

      <!-- フッター -->
      <div class="sidebar-footer">
        <button
          class="nav-item settings-btn"
          :title="'設定'"
          @click="openSettings"
          aria-label="設定を開く"
        >
          <svg class="nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <circle cx="12" cy="12" r="3"/>
            <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/>
          </svg>
          <span class="nav-text">設定</span>
        </button>

        <div class="user-profile" v-if="userName !== 'ゲスト'" :title="userName">
          <div class="user-avatar" aria-hidden="true">{{ userInitials }}</div>
          <div class="user-name">{{ userName }}</div>
        </div>
      </div>
    </aside>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useAuthStore } from '@/store/authStore';
import { useUiStore } from '@/store/ui-store';

const route = useRoute();
const router = useRouter();
const authStore = useAuthStore();
const uiStore = useUiStore();

// サイドバー開閉状態（uiStoreと同期）
const isCollapsed = computed(() => uiStore.isSidebarCollapsed);
const closeSidebar = () => uiStore.closeSidebar();

const isShioriRoute = computed(() => route.path.startsWith('/shiori/'));
const activeTab = computed(() => route.query.tab || 'overview');

const changeTab = (tab) => {
  router.push({ query: { ...route.query, tab } });
  closeSidebar();
};

const openSettings = () => {
  window.dispatchEvent(new CustomEvent('open-settings'));
  closeSidebar();
};

const userName = computed(() => authStore.user?.username || 'ゲスト');
const userInitials = computed(() => {
  if (authStore.user?.username) return authStore.user.username.charAt(0).toUpperCase();
  return 'G';
});
</script>

<style scoped>
/* ── バックドロップ（オーバーレイ） ── */
.sidebar-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(18, 33, 52, 0.45);
  backdrop-filter: blur(2px);
  z-index: 1050;
}

.backdrop-fade-enter-active,
.backdrop-fade-leave-active {
  transition: opacity 0.25s ease;
}

.backdrop-fade-enter-from,
.backdrop-fade-leave-to {
  opacity: 0;
}

/* ── サイドバーコンテナ ── */
.app-sidebar-container {
  width: 280px;
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  height: 100vh;
  height: 100dvh;
  background: var(--color-surface);
  border-right: 1px solid var(--color-border);
  display: flex;
  flex-direction: column;
  z-index: 1100;
  overflow-y: auto;
  overflow-x: hidden;
  transform: translateX(-100%);
  transition: transform 0.28s cubic-bezier(0.4, 0, 0.2, 1);
  box-sizing: border-box;
}

.app-sidebar-container.is-open {
  transform: translateX(0);
  box-shadow: 8px 0 30px rgba(18, 33, 52, 0.18);
}

.app-sidebar-container.is-closed {
  transform: translateX(-100%);
  pointer-events: none;
}

/* ── ヘッダー ── */
.sidebar-header {
  padding: 1.125rem 1rem;
  border-bottom: 1px solid var(--color-border-light);
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  flex-shrink: 0;
  min-height: 60px;
}

.sidebar-brand-link {
  display: flex;
  align-items: center;
  gap: 0.625rem;
  text-decoration: none;
}

.sidebar-logo-img {
  width: 28px;
  height: 28px;
  border-radius: var(--radius-sm);
  flex-shrink: 0;
}

.sidebar-brand {
  font-weight: 800;
  font-size: 1.125rem;
  color: var(--color-text);
  letter-spacing: -0.01em;
}

.sidebar-close-btn {
  background: none;
  border: none;
  color: var(--color-text-muted);
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 0;
  border-radius: var(--radius-sm);
  transition: all var(--transition-fast);
}

.sidebar-close-btn:hover {
  background: var(--color-background);
  color: var(--color-text);
}

.sidebar-close-btn svg {
  width: 20px;
  height: 20px;
}

/* ── ナビゲーション ── */
.sidebar-main-nav {
  padding: 0.75rem 0.625rem;
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex-shrink: 0;
}

.sidebar-sub-nav {
  border-top: 1px solid var(--color-border-light);
  padding: 0.75rem 0.625rem;
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex-shrink: 0;
}

.sub-nav-label {
  padding: 0.375rem 0.875rem 0.5rem;
  font-size: 0.6875rem;
  font-weight: 700;
  color: var(--color-text-muted);
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

/* ナビアイテム共通 */
.nav-item {
  display: flex;
  align-items: center;
  gap: 0.875rem;
  padding: 0.625rem 0.875rem;
  border-radius: var(--radius-md);
  color: var(--color-text-muted);
  text-decoration: none;
  font-size: 0.875rem;
  font-weight: 600;
  border: none;
  background: none;
  cursor: pointer;
  width: 100%;
  text-align: left;
  transition: all var(--transition-fast);
  white-space: nowrap;
}

.nav-item:hover {
  background: var(--color-background);
  color: var(--color-text);
}

.nav-item.router-link-active,
.nav-item.active {
  background: var(--color-primary-light);
  color: var(--color-primary-ink);
  font-weight: 700;
}

.nav-icon {
  width: 20px;
  height: 20px;
  flex-shrink: 0;
}

.nav-text {
  flex: 1;
}

/* ── フッター ── */
.sidebar-footer {
  margin-top: auto;
  border-top: 1px solid var(--color-border-light);
  padding: 0.75rem 0.625rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.user-profile {
  display: flex;
  align-items: center;
  gap: 0.625rem;
  padding: 0.5rem 0.875rem;
  border-radius: var(--radius-md);
  background: var(--color-background);
  overflow: hidden;
}

.user-avatar {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: var(--color-primary);
  color: var(--color-primary-ink);
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 0.75rem;
  flex-shrink: 0;
}

.user-name {
  font-size: 0.8125rem;
  font-weight: 600;
  color: var(--color-text);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
